import React, { FC } from 'react';

import cx from 'clsx';
import { useLocale, useLogOperatorAction } from 'lib';
import { useDispatch, useSelector } from 'react-redux';
import { procedurePrioritySelector, setProcedurePriority } from 'features/details';
import { ProcedurePriority } from 'types';
import { ackedSelector } from 'features/details/ack/exports';
import styles from './style.module.scss';

export const ProcedurePriorityButtons: FC = () => {

  const { t } = useLocale();
  const dispatch = useDispatch();
  const currentPriority = useSelector(procedurePrioritySelector);
  const acked = useSelector(ackedSelector);
  const logAction = useLogOperatorAction();

  const select = (priority: ProcedurePriority) => {

    if (acked || currentPriority === priority) return;

    logAction(priority === 'verification'
      ? 'ACTION_PROTOCOL_VERIFICATION'
      : 'ACTION_PROTOCOL_HELP');

    dispatch(setProcedurePriority(priority));

  };

  const choice = (priority: ProcedurePriority, title: string, detail: string) => (
    <label className={cx(styles.choice, currentPriority === priority && styles[priority])}>
      <input
        type="radio"
        name="procedurePriority"
        checked={currentPriority === priority}
        onChange={() => select(priority)}
        disabled={acked}
      />
      <span className={styles.choiceCopy}>
        <span className={styles.choiceTitle}>{title}</span>
        <span className={styles.choiceDetail}>{detail}</span>
      </span>
    </label>
  );

  return (
    <div className={styles.choices}>
      {choice(
        'verification',
        t('Alarm_Detail_Response_Procedure.Priority.Verification'),
        t('Alarm_Detail_Response_Procedure.Priority.VerificationDetail'),
      )}
      {choice(
        'help',
        t('Alarm_Detail_Response_Procedure.Priority.Help'),
        t('Alarm_Detail_Response_Procedure.Priority.HelpDetail'),
      )}
    </div>
  );

};
